import { Action } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { of, Observable } from 'rxjs';
import { flatMap, pluck, filter } from 'rxjs/operators';

import { GE } from '@ezugi/constants';

import { dialogActions, tipsActions } from '../../actions';
import { LOW_BALANCE_DIALOG } from '../../constants/dialog';
import { buildSocketSendPayload } from '../../epics/socket/buildSocketSendPayload';
import {
  userBalanceSelector,
  totalBetSelector,
  showTipsSelector,
} from '../../selectors';
import { RootState } from '../../types';

const { tips } = tipsActions;
const { dialog } = dialogActions;

const buildParams = (tipValue: number, state: RootState) => {
  const { roundId: _, ...params } = buildSocketSendPayload(state);
  return {
    ...params,
    MessageType: GE.OUT.SOCKET_SEND.MESSAGE_TYPE.PLACE_TIP,
    destination: GE.OUT.SOCKET_SEND.DESTINATION.TABLE,
    tipValue,
  };
};

const tipsRequestEpic = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(tips.request.match),
  pluck('payload'),
  flatMap((tipValue: any) => {
    const balance = userBalanceSelector(state$.value);
    const totalBet = totalBetSelector(state$.value);

    if (balance < totalBet + tipValue) {
      return of(tips.failure(), dialog.add({ name: LOW_BALANCE_DIALOG }));
    }

    return of(tips.send(buildParams(tipValue, state$.value)));
  })
);

const tipsToggleEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>
): Observable<any> => action$.pipe(
  filter(tips.toggleRequest.match),
  flatMap(() => {
    const balance = userBalanceSelector(state$.value);
    const totalBet = totalBetSelector(state$.value);
    const showTips = showTipsSelector(state$.value);

    // Only show LOW_BALANCE when trying to open, not close the tips widget
    if (balance <= totalBet && !showTips) {
      return of(dialog.add({ name: LOW_BALANCE_DIALOG }), tips.toggleFailure());
    }

    return of(tips.toggleSuccess());
  })
);

export default combineEpics(tipsRequestEpic, tipsToggleEpic);
